import { create } from 'zustand';

interface DigestDeleteModalProps {
  digestName?: string;
  slug?: string;
  isOpen: boolean;
  id: number;
  refetchPeriodReports: () => void;
  closeDeleteDigestModal: () => void;
  openDeleteDigestModal: (slug: string, refetchPeriodReports: () => void, id: number) => void;
}
export const useDigestDeleteModalStore = create<DigestDeleteModalProps>(set => ({
  isOpen: false,
  digestName: '',
  slug: '',
  id: 0,
  refetchPeriodReports: () => {},
  openDeleteDigestModal: (slug: string, refetchPeriodReports: () => void, id: number) =>
    set({ isOpen: true, slug, refetchPeriodReports, id }),
  closeDeleteDigestModal: () => set({ isOpen: false, digestName: '', slug: '' }),
}));
